import axios from "axios";

export interface PublicConfig {
  authMode: "EntraGroups" | "Local";
}

export const fetchPublicConfig = async (): Promise<PublicConfig> => {
  const { data } = await axios.get<PublicConfig>(
    `${import.meta.env.VITE_BASE_URL}/api/v1/config/public`
  );
  return data;
};
